/* src/app/components/add-edit-execution/add-edit-execution.component.scss */
.execution-wrapper {
  display: flex;
  height: calc(100vh - 96px);
  overflow: hidden;
}
.execution-wrapper app-execution-sidebar {
  flex: 0 0 33.75rem;
  max-width: 33.75rem;
}
.execution-wrapper .container-tool {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: calc(100vh - 96px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 3.5rem 16%;
}
.execution-wrapper .container-tool .key-sets {
  font-size: 0.875rem;
  line-height: 1.25rem;
  border-bottom: 0.25rem solid transparent;
  color: #2e2e38;
  padding-bottom: 0.25rem;
}
.execution-wrapper .container-tool .key-sets-wrapper {
  margin-top: 4rem;
  font-size: 1.125rem;
  line-height: 1.5rem;
  color: #72727f;
}
.execution-wrapper .container-tool .key-sets-wrapper .title {
  padding-bottom: 0.5rem;
}
.execution-wrapper .container-tool .key-sets-wrapper .set-description {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #72727f;
  margin: 1.5rem 0 1rem 0;
}
.execution-wrapper .container-tool h1 {
  font-size: 2rem;
  line-height: 2.5rem;
  font-weight: 300;
  color: #2e2e38;
  margin: 0;
}
.execution-wrapper .container-tool .config {
  display: flex;
  margin-top: 0.5rem;
}
.execution-wrapper .container-tool .config:first-child {
  margin-top: 0;
}
.execution-wrapper .container-tool .config .name {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgba(46, 46, 56, 0.64);
  margin: 0;
}
.execution-wrapper .container-tool .config .name-container {
  padding: 0.875rem 0;
}
.execution-wrapper .container-tool .config .name-container,
.execution-wrapper .container-tool .config .select-container {
  flex: 1;
  width: 50%;
}
.execution-wrapper .container-tool .config .select-container {
  padding: 0;
}
.execution-wrapper .container-tool .config .select-container .section-type-btn {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  padding: 0.875rem 1rem;
  min-width: 4rem;
}
.execution-wrapper .container-tool .your-files {
  font-size: 1.125rem;
  line-height: 1.5rem;
  color: #72727f;
  margin: 4rem 0 1.5rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 0.0625rem solid rgba(46, 46, 56, 0.08);
}
.execution-wrapper .container-tool .file-description {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #72727f;
  margin: 1.5rem 0 1rem 0;
}
.execution-wrapper .container-tool .section-list-container.show {
  display: flex;
  flex-direction: column;
}
.execution-wrapper .container-tool .section-list-container .stress-name-container {
  order: -1;
  padding-bottom: 0.9375rem;
  border-bottom: 0.0625rem solid rgba(46, 46, 56, 0.08);
}
.execution-wrapper .container-tool .section-list-container .stress-name-container .input-container {
  padding: 0 0.9375rem;
}
.execution-wrapper .container-tool .section-container {
  width: 100%;
}
.execution-wrapper .container-tool .section-container .nota {
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 300;
  color: rgba(46, 46, 56, 0.64);
}
.execution-wrapper .container-tool .section-container .input-toggle {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.375rem 1rem 0.375rem;
  border-top: 0.0625rem solid rgba(46, 46, 56, 0.08);
  margin-top: 1.5rem;
}
.execution-wrapper .container-tool .section-container .input-toggle p {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgba(46, 46, 56, 0.64);
}
.execution-wrapper .container-tool .section-container .no-border {
  border: 0;
  margin-top: 1rem;
}
.execution-wrapper .container-tool .section-container.full-width {
  margin: 0 -1rem;
  width: auto;
}
.execution-wrapper .configuration .title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
  border-bottom: 0.0625rem solid rgba(46, 46, 56, 0.08);
}
.execution-wrapper .configuration .title-wrapper .title {
  margin: 0;
  font-size: 1.125rem;
  line-height: 1.5rem;
  color: #72727f;
}
.execution-wrapper .configuration .title-wrapper .btn {
  padding: 0;
}
.execution-wrapper .configuration .config-description {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #72727f;
  margin-bottom: 2rem;
}
.execution-wrapper .tab-configurator {
  border: 1px solid rgba(46, 46, 56, 0.08);
  margin-top: 1.5rem;
  padding: 1rem;
}
.execution-wrapper .tab-configurator.open-collapse {
  padding: 0;
  border: 0;
}
.execution-wrapper .tab-configurator .rr {
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.execution-wrapper .tab-configurator .rr-text-normal {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #72727f;
}
.tab-configuration-collapse,
.btn-stress-type {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-radius: 0;
  border: 1px solid rgba(46, 46, 56, 0.08);
  padding: 1.125rem 1rem;
}
.tab-configuration-collapse .btn-label,
.btn-stress-type .btn-label {
  color: rgba(46, 46, 56, 0.32);
  font-size: 0.875rem;
  line-height: 1.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 1.5625rem;
}
.tab-configuration-collapse .btn-link,
.btn-stress-type .btn-link {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  color: #155cb4;
  text-decoration: none;
}
.btn-stress-type {
  margin-top: 1.5rem;
}
.btn-stress-type .btn-icon {
  font-size: 1.5625rem;
  color: #155cb4;
}
.tab {
  border: 1px solid rgba(46, 46, 56, 0.08);
}
.tabs-wrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 0.9375rem;
  align-items: flex-end;
  overflow: hidden;
  border-bottom: 1px solid rgba(46, 46, 56, 0.08);
}
.tabs-wrapper .btn-link {
  margin-bottom: 0.5rem;
  padding: 0;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  flex: 0 0 auto;
}
.tabs-wrapper .tabs-container {
  display: flex;
  align-items: center;
  overflow: auto;
  margin-right: 0.625rem;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.tabs-wrapper .tabs-container::-webkit-scrollbar {
  display: none;
}
.tabs-wrapper .tabs-container .key-sets {
  margin-right: 1.5625rem;
  flex: 0 0 auto;
}
.tabs-wrapper .tabs-container .key-sets:last-child {
  margin-right: 0;
}
.section-header-container {
  padding: 0.9375rem;
  border-bottom: 1px solid rgba(46, 46, 56, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.section-header-container .text-error {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  padding: 0;
}
.section-header-container .section-title {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #2e2e38;
}
.delete-btn-container {
  border-top: 1px solid rgba(46, 46, 56, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem -1rem -1rem;
  padding: 1.125rem 1rem;
}
.delete-btn-container .delete-label {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 300;
  color: #72727f;
}
.delete-btn-container .text-error {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  padding: 0;
  border: 0;
}
.delete-btn-container .text-error[disabled] {
  opacity: 1;
  color: rgba(46, 46, 56, 0.32) !important;
  cursor: auto;
}
.section-configurations-select .title {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgba(46, 46, 56, 0.64);
  margin-bottom: 0.5rem;
}
/*# sourceMappingURL=add-edit-execution.component.css.map */
